import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    margin-left: 10px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 20px;\n  font-size: 10px;\n  line-height: 160%;\n  color: red;\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      font-size: 14px;\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      font-size: 14px;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      top: 1px;\n      left: 5px;\n      font-size: 18px;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  bottom: 15px;\n  left: 0;\n  input:checked + div span:after {\n    top: 0px;\n    left: 6px;\n    font-size: 18px;\n    ", "\n  }\n  .accepted-checkbox {\n    font-family: ", ";\n    font-size: 16px;\n    line-height: 160%;\n    color: #2c2c2c;\n    margin-bottom: 0;\n    margin-right: 3px;\n    ", "\n  }\n  a {\n    font-family: ", ";\n    font-size: 16px;\n    line-height: 160%;\n    color: #2c2c2c;\n    text-decoration: underline;\n    ", "\n  }\n  > div {\n    label {\n      div[role=\"button\"] {\n        span {\n          border-color: #c34c3e;\n        }\n      }\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: #21125e;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    padding: 20px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  background-color: ", ";\n  padding: 30px 40px;\n  font: 16px ", ";\n  ", "\n  cursor: pointer;\n  * {\n    color: ", ";\n  }\n  & > div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    & > div {\n      display: none;\n    }\n  }\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font: 14px ", ";\n  line-height: 1.5em;\n  color: #839098;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font: 30px ", ";\n  line-height: 1.1em;\n  margin-bottom: 30px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-gap: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var ShippingMethodForm = styled.form(_templateObject());
export var Title = styled.h3(_templateObject2(), function (props) {
  return props.theme.typography.thinFontFamily;
});
export var Text = styled.p(_templateObject3(), function (props) {
  return props.theme.typography.extraFontFamily;
});
export var Tile = styled.label(_templateObject4(), function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.theme.typography.extraFontFamily;
}, function (props) {
  return props.checked && "border: 1px solid ".concat(props.theme.colors.red, ";");
}, function (props) {
  return props.theme.colors.baseFont;
}, media.largeScreen(_templateObject5()));
export var Price = styled.span(_templateObject6());
export var CheckboxWr = styled.div(_templateObject7(), media.xxLargeScreen(_templateObject8()), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject9()), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject10()));
export var ErrorMsg = styled.div(_templateObject11(), media.extraSmallScreen(_templateObject12()));